import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/kinekt-new/process-back.webp";

function Processbreakdown() {
  return (
    <section className="process-breakdown p-100">
      <Container>
        <div
          className="process-breakdown-box"
          style={{ backgroundImage: `url(${BgImg})` }}
        >
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="text-center mb-4"
            >
              <h2 className="head-h2-kinekt">
                Process <span style={{ color: "#20A2BE" }}>Breakdown</span>
              </h2>
              <h3>(Step-by-Step Approach)</h3>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <div className="steps-main">
                <div className="steps-item">
                  <div className="steps-num">01</div>
                  <h5 style={{ color: "#20A2BE" }}>Conceptualization</h5>
                  <ul>
                    <li>Conducted market research & competitor analysis.</li>
                    <li>Identified key pain points in patient engagement.</li>
                  </ul>
                </div>
                <div className="steps-item">
                  <div className="steps-num">02</div>
                  <h5 style={{ color: "#20A2BE" }}>Design & Development</h5>
                  <ul>
                    <li>
                      UI/UX Revamp – Created a modern, intuitive interface.
                    </li>
                    <li>
                      Mobile & Web Development – Built robust apps for seamless
                      interaction.
                    </li>
                  </ul>
                </div>
                <div className="steps-item">
                  <div className="steps-num">03</div>
                  <h5 style={{ color: "#20A2BE" }}>AI Integration</h5>
                  <ul>
                    <li>
                      GPT-4 for AI-powered responses – Enabled real-time,
                      natural interactions.
                    </li>
                    <li>
                      Sentiment Analysis & Social Monitoring – Delivered
                      actionable insights to care providers.
                    </li>
                  </ul>
                </div>
                <div className="steps-item">
                  <div className="steps-num">04</div>
                  <h5 style={{ color: "#20A2BE" }}>Deployment & Support</h5>
                  <ul>
                    <li>Launched apps on the Play Store & App Store.</li>
                    <li>
                      Provided post-launch updates & continuous monitoring.
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Processbreakdown;
